import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';
import {
  updatePaymentConfigSuccess,
  updatePaymentConfigFailure,
  fetchPaystackConfig,
  fetchRemitaConfig,
  fetchInterswitchConfig,
} from '../actions';
import paymentConfigTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* updatePaymentConfig({ payload: { paymentConfig, cb } }) {
  const url = `${API_BASE_URL}/paylog-configurations/${paymentConfig.id}`;
  const data = {
    configId: Number(paymentConfig.newId),
  };
  const response = yield request({
    method: 'put',
    data,
    url,
  });

  if (response.success) {
    if (response.raw.paymentPlatform === 'REMITA') {
      yield put(fetchRemitaConfig(response.raw.id));
    } else if (response.raw.paymentPlatform === 'PAYSTACK') {
      yield put(fetchPaystackConfig(response.raw.id));
    } else if (response.raw.paymentPlatform === 'INTERSWITCH') {
      yield put(fetchInterswitchConfig(response.raw.id));
    }
    cb();
    yield put(updatePaymentConfigSuccess());
    Notify(
      `${response.raw.paymentPlatform} bank accounts updated successfully`,
      {
        position: TOP_RIGHT,
        status: SUCCESS,
      }
    );
  } else {
    yield put(
      updatePaymentConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    if (response.statusCode === 400) {
      networkErrorHandler(response?.statusCode, 'Invalid paylog ID');
    } else if (response.statusCode === 409) {
      networkErrorHandler(response?.statusCode, 'Provided paylog id already exists');
    } else {
      networkErrorHandler(response?.statusCode, 'An error occured. Please reload the page to try again.');
    }
  }
}

export function* onUpdatePaymentConfig() {
  yield takeLatest(
    paymentConfigTypes.UPDATE_PAYMENT_CONFIG_REQUEST,
    updatePaymentConfig
  );
}
